var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper background-gray"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-xl-10 col-lg-12 col-md-9"},[_c('div',{class:{
            'card shadow-lg': _vm.isShowCard,
            'o-hidden border-0 my-5': true,
          }},[_c('div',{class:{
              'card-body': _vm.isShowCard,
              'p-0': true,
            }},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 mb-5"},[_c('h1',{staticClass:"h2 text-gray-900 font-weight-bold py-5 px-2 m-0"},[_vm._v(" 県立病院職員マスタ一元化システム ")]),_c('div',{staticClass:"col-lg-10 offset-lg-1"},[_vm._t("default")],2)])])])])])])]),_c('Footer',{staticClass:"footer"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }